export const performancePageSelector = (state: any) => state.performancePage;

export const performancePagePeriodSelector = (state: any) =>
  state.performancePage.period;

export const getSelectedListingsSelector = (state: any) =>
  state.performancePage.listings;
